import Button from "./Button";

const SectionHeader = ({
    title,
    subtitle,
    actionLabel,
    actionIcon,
    onAction,
    actionDisabled = false,
    actionVariant = "primary",
    rightSlot,
    className = "",
    titleClassName = "text-lg font-semibold text-slate-900",
    subtitleClassName = "mt-1 text-sm text-slate-500",
    actionClassName = "w-full md:w-auto",
}) => {
    return (
        <div className={`flex flex-col gap-4 border-b border-slate-200 pb-6 md:flex-row md:items-start md:justify-between ${className}`}>
            <div>
                <h1 className={titleClassName}>{title}</h1>
                {subtitle ? <p className={subtitleClassName}>{subtitle}</p> : null}
            </div>
            {rightSlot ? rightSlot : null}
            {actionLabel ? (
                <Button
                    type="button"
                    variant={actionVariant}
                    onClick={onAction}
                    disabled={actionDisabled}
                    className={actionClassName}
                >
                    {actionIcon ? <span className="inline-flex items-center gap-1.5">{actionIcon}{actionLabel}</span> : actionLabel}
                </Button>
            ) : null}
        </div>
    );
};

export default SectionHeader;
